import EditNoteIcon from '@mui/icons-material/EditNote';
import { Menu, Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { type AxiosResponse } from 'axios';
import React, { type FC } from 'react';

import useSnackBar from '../../hooks/use-snack-bar.js';
import { Events, track } from '../../utils/index.js';
import LogForm from '../Logs/LogForm.js';

interface StreamsLogsMenuProps {
  patientId?: string;
}
const PatientLogsMenu: FC<StreamsLogsMenuProps> = ({ patientId }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const snackBar = useSnackBar();
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const confirmLogSaved = (response: AxiosResponse) => {
    const {
      data: { codeId },
    } = response;
    snackBar.success('Log updated successfully!');
    track(Events.LogCreation, {
      codeId,
      patientId,
    });
  };

  return (
    <>
      <Tooltip arrow color="primary" placement="bottom" title={'Add a new log'}>
        <IconButton
          color="inherit"
          edge="start"
          id="logs-menu-button"
          aria-controls={open ? 'logs-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          sx={{
            mr: 2,
          }}
        >
          <EditNoteIcon />
        </IconButton>
      </Tooltip>
      <Menu
        id="logs-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'logs-menu-button',
        }}
        sx={{
          '& .MuiMenu-paper': {
            width: 300,
            p: 1,
          },
        }}
      >
        <LogForm
          patientId={patientId}
          onSuccess={(response) => {
            confirmLogSaved(response);
            handleClose();
          }}
        />
      </Menu>
    </>
  );
};

export default PatientLogsMenu;
